<template>
  <div>
    <ListItemFilters
      icon="ui-icon-calendar-none"
      :title="t(title, options)"
      :subtitle="subtitle"
      @click="openDialog"
    />

    <DateModal
      :value="isDialogOpened"
      is-back
      @input="handleClosePlaceModal"
    >
      <template #footer>
        <div class="pa-2 elevation-8">
          <v-btn
            block
            depressed
            color="primary"
            :disabled="!hasUnsavedDate"
            @click="handleDateSelected"
          >
            {{ t('Применить', options) }}
          </v-btn>
        </div>
      </template>
    </DateModal>
  </div>
</template>

<script setup lang="ts">
import { toRefs, computed } from 'vue'
import I18NextVue from 'i18next'
import deepEqual from 'www/vue_components/common/TheFilters/doctors/functions/deepEqual'
import getDateLabel from 'www/vue_components/common/TheFilters/doctors/components/DateFilters/functions/getDateLabel'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import DateModal from 'www/vue_components/common/TheFilters/doctors/components/DateFilters/components/DateModal.vue'
import ListItemFilters from 'www/vue_components/common/TheFilters/common/components/ListItemFilters/ListItemFilters.vue'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('ListItemDate')

const title = computed(() => getDateLabel({
  dateRange: doctorFiltersState.value.dateRange,
  timesOfDay: doctorFiltersState.value.timesOfDay,
}))

const subtitle = computed(() => ((doctorFiltersState.value.dateRange || doctorFiltersState.value.timesOfDay)
  ? t('Дата и время', options.value)
  : undefined))

const hasUnsavedDate = computed(() => (
  !deepEqual(doctorFiltersState.value.dateRange, filtersStore.unsavedFilters.dateRange)
  || !deepEqual(doctorFiltersState.value.timesOfDay, filtersStore.unsavedFilters.timesOfDay)
))

function handleDateSelected() {
  closeDialog()

  const [startDate, endDate] = filtersStore.unsavedFilters.dateRange || []
  const newDateRange = startDate ? [startDate, endDate || startDate] : undefined
  const newTimesOfDay = filtersStore.unsavedFilters.timesOfDay

  emit('input', {
    ...doctorFiltersState.value,
    dateRange: newDateRange,
    timesOfDay: newTimesOfDay,
  })
}

const handleClosePlaceModal = () => {
  closeDialog()
  filtersStore.updateUnsavedFilters(doctorFiltersState.value)
}
</script>
